import React from 'react'
import { ICellEditorParams, ICellEditor } from 'ag-grid-community'

export class NoopCellEditor extends React.Component<ICellEditorParams> implements ICellEditor {
  render() {
    return null
  }

  public getValue = () => null

  public focusIn = () => {
    return {}
  }
}
